import { z } from 'zod'
import { useZorm } from 'react-zorm'
import { FormField, fieldDescription } from '@codecorp/zorm-conventions'
import { ShowBarcode } from '../components/show-barcode'
import { CreatorButtons } from '../components/creator-buttons'
import { useFormReset } from '../hooks/use-form'
import { useShowModal } from '../hooks/use-show-modal'

const FormSchema = z.object({
    label: z.string().describe(
        fieldDescription({
            placeHolder: 'This name will be placed under the QR Code.',
        })
    ),
    contents: z
        .string()
        .min(1)
        .describe(fieldDescription({ placeHolder: 'Enter your text here' })),
})

export const BasicBarcodeCreator = () => {
    const { setSubmittedBarcode, handleFormReset } = useFormReset(undefined)

    const showModal = useShowModal()
    const zo = useZorm('basicBarcode', FormSchema, {
        onValidSubmit: async ({ preventDefault, data }) => {
            preventDefault()

            setSubmittedBarcode(data)
            showModal(
                <ShowBarcode
                    label={data.label}
                    barcode={data.contents}
                />
            )
        },
    })

    return (
        <div className="w-full max-w-full px-4 sm:px-6 md:px-2 lg:px-5">
            <form
                ref={zo.ref}
                className="ml-10  leading-10"
                onReset={handleFormReset}
            >
                {zo.fields.label(FormField)}
                {zo.fields.contents(FormField)}

                <CreatorButtons />
            </form>
        </div>
    )
}
